import { render } from "./medical-prescription.vue?vue&type=template&id=0daf8d32"
import script from "./medical-prescription.vue?vue&type=script&lang=js"
export * from "./medical-prescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__